import { VIEW_ENTITY_TYPES } from '@frontend/api';

export const viewsBaseRoute = '/views';

export const DEFAULT_PAGE = 1;

export const PAGE_SIZE = 20;

export const ARRAY_SEPARATOR = ',';

export const DESCENDING_ORDER_PREFIX = '-';

export const DESCENDING_ORDER_VALUE = 'descending';

export const ASCENDING_ORDER_VALUE = 'ascending';

export const VIEW_SIDEBAR_OPEN_VALUE = 'true';

export const VIEW_SIDEBAR_CLOSED_VALUE = 'false';

export const VIEW_SIDEBAR_PARAMETER_KEY = 'show_views';

export const ENTITY_PARAMETER_KEY = 'entity';

export const ROLLUP_STATUS_BAR_PARAMETER_KEY = 'status_bar';

export const COLUMN_PARAMETER_KEY = 'columns';

export const ORDER_PARAMETER_KEY = 'o';

export const PAGE_PARAMETER_KEY = 'page';

export const SEARCH_PARAMETER_KEY = 'search';

export const VIEW_PARAMETER_KEY = 'view_id';

export const FILTER_VALUE_MAP_PARAMETER_KEY = 'filter_value_map';

export const WORKFLOW_STEP_PREFIX = 'workflow_step_';

export const VIEW_ENTITY_DISPLAY_NAME = {
  [VIEW_ENTITY_TYPES.QUOTE_ITEMS as string]: 'line items',
  [VIEW_ENTITY_TYPES.QUOTES as string]: 'quotes',
} as const;

export const DEFAULT_ENTITY = VIEW_ENTITY_TYPES.QUOTES;

export const NON_FILTER_PARAM_KEYS = [
  VIEW_SIDEBAR_PARAMETER_KEY,
  PAGE_PARAMETER_KEY,
  VIEW_PARAMETER_KEY,
  ENTITY_PARAMETER_KEY,
  ORDER_PARAMETER_KEY,
  COLUMN_PARAMETER_KEY,
  FILTER_VALUE_MAP_PARAMETER_KEY,
  ROLLUP_STATUS_BAR_PARAMETER_KEY,
];

export const METADATA_KEY_PREFIX = 'metadata_';

export const QUOTE_ITEM_QUERY_PARAMS = {
  PART_NUMBER: 'part_number',
  PART_DESCRIPTION: 'part_description',
  QUOTE_NUMBER: 'quote_number',
  RFQ_NUMBER: 'rfq_number',
  ESTIMATOR: 'estimator',
  QUOTE_SALESPERSON: 'quote_salesperson',
  QUOTE_STATUS: 'quote_status',
  QUOTE_ITEM_STATUS: 'quote_item_status',
  PROCESS: 'process',
  MATERIAL: 'material',
  FINISH: 'finish',
  PRIORITY: 'priority',
  ACCOUNT: 'account',
  CONTACT: 'contact',
  QUANTITIES: 'quantities',
  PRICE: 'price',
  CREATED: 'created',
  DUE: 'due',
  SENT: 'sent',
  VIEWED: 'viewed',
  EXPIRED: 'expired',
  ORDERED: 'ordered',
  WORKFLOW_STEPS: 'workflow_steps',
  OP_DEF: 'op_def',
  FACILITY: 'quote_facility',
  ESTIMATED_ANNUAL_USAGE: 'estimated_annual_usage',
} as const;

export const QUOTE_QUERY_PARAMS = {
  NUMBER: 'number',
  RFQ_NUMBER: 'rfq_number',
  QUOTE_STATUS: 'quote_status',
  PRIORITY: 'priority',
  ACCOUNT: 'account',
  CONTACT: 'contact',
  SALESPERSON: 'salesperson',
  ESTIMATOR: 'estimator',
  QUOTE_ITEM_STATUS: 'quote_item_status',
  QUOTE_ITEMS_COUNT: 'quote_items_count',
  PRICE: 'price',
  CREATED: 'created',
  RECEIVED: 'received',
  DUE: 'due',
  SENT: 'sent',
  VIEWED: 'viewed',
  EXPIRED: 'expired',
  ORDERED: 'ordered',
  METADATA: 'metadata',
  WORKFLOW_STEPS: 'workflow_steps',
  IS_OPENED: 'is_opened',
  FACILITY: 'facility',
} as const;
